import React, { useEffect, useState } from "react";
import user from "../../assets/img/user 1.svg";
import dele from "../../assets/img/slash.svg";
import edit from "../../assets/img/edit-3.svg";

import { formatDistanceToNow, formatDistance } from 'date-fns';

import { BrowserRouter as Router, Switch, Route, Link, useNavigate } from 'react-router-dom';

const ListDiscussions = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  const post = props.post;
  const userData = props.userData;
  const fullName = post?.user?.[0]?.lastName 
                  ? `${post.user[0].firstName} ${post.user[0].lastName}` 
                  : post?.user?.[0]?.firstName || "Unknown User";

const profile_image_url = post?.user?.[0]?.profileImage?.url 
                          ? process.env.REACT_APP_IMAGE_URL + post.user[0].profileImage.url 
                          : user;

  const slugify = (text = "") =>
  text
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");


  const handleImageClick = (first,last,id,type) => {
    if(type === "individual"){
       const userName = `${slugify(first)}-${slugify(last)}`;
       if(userData._id === id)
       navigate('/profile');
       else
       navigate(`/profile/${userName}`, { state: { userId: id } })
    }else{
         if(userData._id === id)
         navigate('/organization');
        else
        navigate(`/organization/${slugify(first)}`, { state: { userId: id } })
    }
   
  };
  return (
    <div ref={ref} key={props.index} className="profile-section">
    
  <div className="single posts">
        <div className="user-post">
          <div className="p-img">
            <div className="post-avatr-wrap">
              {post.user[0].profileSettings.isPrivateProfile === false && post.user[0].profileSettings.showprofileImage === true ? (

                <img src={profile_image_url} className="avar-post" alt="User Profile"
                  style={{ cursor: "pointer", }} onClick={() => {
                    handleImageClick(post.user[0].firstName, post.user[0].lastName,post.user[0]._id,post.user[0].userType);
                  }}
                />
              ) : (
                <img src={user} className="avar-post" alt="User Profile"
                  style={{ cursor: "pointer", }} onClick={() => {
                    handleImageClick(post.user[0].firstName,  post.user[0].lastName, post.user[0]._id,post.user[0].userType);
                  }} />
              )}

              {/* Dynamically set user name */}
              <span className="avatarname-post" style={{ cursor: "pointer", }}
                onClick={() => handleImageClick(post.user[0].firstName, post.user[0].lastName,post.user[0]._id,post.user[0].userType)}>
                {fullName}
                </span>

              {/* Favourite */}
               {post.user[0]._id !== userData._id &&
                            (
                              (userData.userType === 'individual') ||
                              (userData.userType === 'organization' && post.user[0].userType === 'organization')
                            )?
                              (
                              <span
                                className="star-rating"
                                style={{ fontSize: '1rem', cursor: 'pointer', color: props.favourites[post.user[0]._id] ? '#ffc107' : '#e4e5e9' }}
                                onClick={() => {
                                     
                                  props.showFavourite(post.user[0]._id, fullName, post.favouritemember.length); // Show the favorite modal
              
                                }}>
                                &#9733;
                              </span>) : (null)
                            }
              

              <span className="timing">{formatDistanceToNow(new Date(post.createdAt), { addSuffix: true })}</span>
            </div>
          </div>
        </div>

        <div className="community-itmpost-right">
          <h5 className="comunity-name-post mb-0"></h5>
        
        <div className="moreoption">

            {post.user[0]._id === userData._id ? (
              <div class="dropdown">
                <button className="more" onClick={() => props.setShow(true)}>&#x22EE;</button>
                <div class="dropdown-content">
                  <Link className="button edit" onClick={(e) => { e.preventDefault(); props.handleEdit(post) }}>  <img src={edit} className="edit-img" alt="Comments" /> Edit</Link>

                  <Link className="button delet" onClick={(e) => { e.preventDefault(); props.DeletPost(post._id) }}>
                    <img src={dele} className="edit-img" alt="Comments" /> Delete</Link>
                </div>

              </div>
            ) : (post.user[0].userType ==="individual" &&(
              <button className="more" onClick={() => props.showReport(post._id)}>&#x22EE;</button>)
            )}

          </div>
        </div>
      </div>

<div className="post-content" dangerouslySetInnerHTML={{ __html: post.postDescription }} />
 

       
     
     


    </div>
  )


});
export default ListDiscussions;